// Define ui-datepicker as a primitive
AFRAME.registerPrimitive('ui-datepicker', {
    defaultComponents: {
        'ui-datepicker': {}
    },
    mappings: {
        width: 'ui-datepicker.width',
        height: 'ui-datepicker.height',
        color: 'ui-datepicker.color',
        'text-color': 'ui-datepicker.textColor',
        days: 'ui-datepicker.days',
        label: 'ui-datepicker.label' // New label attribute
    }
});

// Register the ui-datepicker component
AFRAME.registerComponent('ui-datepicker', {
    schema: {
        width: { type: 'number', default: 0.75 },
        height: { type: 'number', default: 0.2 },
        color: { type: 'string', default: '#174a55' },
        textColor: { type: 'string', default: 'white' },
        days: { type: 'array', default: [-30, 0] }, // [pastDays, futureDays]
        label: { type: 'string', default: '' } // New label property
    },

    init: function () {
        this.currentDate = new Date().toISOString().split('T')[0];
        this.isOpen = false;
        this.dateButtons = [];
        this.createDatepicker();
        this.bindEvents();
    },

    createDatepicker: function () {
        const { width, height, color, textColor, label } = this.data;

        // Label above datepicker button
        if (label) {
            this.labelText = document.createElement('a-text');
            this.labelText.setAttribute('value', label);
            this.labelText.setAttribute('align', 'center');
            this.labelText.setAttribute('position', `0 ${height} 0`); // Above button
            this.labelText.setAttribute('color', textColor);
            this.labelText.setAttribute('font', 'roboto');
            this.labelText.setAttribute('shader', 'msdf');
            this.labelText.setAttribute('negate', 'true');
            this.labelText.setAttribute('scale', '0.5 0.5 0.5');
            this.labelText.setAttribute('class', 'no-raycast'); // Pass-through events
            this.el.appendChild(this.labelText);
        }

        // Base button (rounded-box)
        this.baseButton = document.createElement('ui-button');
        this.baseButton.setAttribute('type', 'rounded-box');
        this.baseButton.setAttribute('label', this.currentDate);
        this.baseButton.setAttribute('width', width);
        this.baseButton.setAttribute('height', height);
        this.baseButton.setAttribute('depth', 0.05);
        this.baseButton.setAttribute('radius', 0.05);
        this.baseButton.setAttribute('color', color);
        this.baseButton.setAttribute('opacity', 1.0);
        this.baseButton.setAttribute('position', '0 0 0');
        this.el.appendChild(this.baseButton);

        // Datepicker grid container
        this.gridContainer = document.createElement('a-entity');
        this.gridContainer.setAttribute('visible', false);
        this.gridContainer.setAttribute('position', '0 0 0');
        this.el.appendChild(this.gridContainer);

        // Opaque background plane for calendar grid
        this.backgroundPlane = document.createElement('a-entity');
        this.backgroundPlane.setAttribute('geometry', `primitive: plane; width: ${width}; height: ${height * 6}`);
        this.backgroundPlane.setAttribute('material', 'color: #333; opacity: 0.8');
        this.backgroundPlane.setAttribute('position', `0 ${-(height * 6) / 2} -0.01`);
        this.gridContainer.appendChild(this.backgroundPlane);

        // Generate date grid
        this.updateDateGrid();
    },

    updateDateGrid: function () {
        const { width, height, color } = this.data;
        const dates = this.generateDateOptions(this.data.days);

        // Clear existing buttons
        this.dateButtons.forEach(button => this.gridContainer.removeChild(button));
        this.dateButtons = [];

        // Calendar grid: 7 columns (days of week), up to 6 rows
        const daysPerRow = 7;
        const maxRows = 6;
        const cellWidth = width / daysPerRow;
        const cellHeight = height;

        dates.forEach((date, index) => {
            const row = Math.floor(index / daysPerRow);
            const col = index % daysPerRow;
            if (row >= maxRows) return;

            const dateButton = document.createElement('ui-button');
            dateButton.setAttribute('type', 'plane');
            dateButton.setAttribute('label', date.split('-')[2]);
            dateButton.setAttribute('width', cellWidth * 0.9);
            dateButton.setAttribute('height', cellHeight * 0.9);
            dateButton.setAttribute('color', color);
            dateButton.setAttribute('opacity', 0.9);
            dateButton.setAttribute('position', `${(col - daysPerRow / 2 + 0.5) * cellWidth} ${-(row + 1) * cellHeight} 0.01`);
            dateButton.addEventListener('click', () => {
                this.selectDate(date);
            });
            this.dateButtons.push(dateButton);
            this.gridContainer.appendChild(dateButton);
        });

        // Adjust background plane height to fit rows
        const rowCount = Math.min(Math.ceil(dates.length / daysPerRow), maxRows);
        this.backgroundPlane.setAttribute('geometry', `primitive: plane; width: ${width}; height: ${rowCount * cellHeight}`);
        this.backgroundPlane.setAttribute('position', `0 ${-(rowCount * cellHeight) / 2} -0.01`);
    },

    generateDateOptions: function (days) {
        const [pastDays, futureDays] = days;
        const today = new Date();
        const options = [];

        const startDays = Math.min(pastDays, 0);
        const endDays = Math.max(futureDays, 0);

        for (let i = startDays; i <= endDays; i++) {
            const date = new Date(today);
            date.setDate(today.getDate() + i);
            options.push(date.toISOString().split('T')[0]);
        }

        return options;
    },

    bindEvents: function () {
        this.baseButton.addEventListener('click', () => {
            this.isOpen = !this.isOpen;
            this.gridContainer.setAttribute('visible', this.isOpen);
            console.log('Datepicker toggled:', this.isOpen ? 'open' : 'closed');
        });
    },

    selectDate: function (date) {
        this.currentDate = date;
        this.baseButton.setAttribute('label', date);
        this.isOpen = false;
        this.gridContainer.setAttribute('visible', false);
        this.el.emit('change', { value: date });
        console.log('Date selected:', date);
    },

    update: function (oldData) {
        const { days, label } = this.data;
        if (days !== oldData.days || label !== oldData.label) {
            this.currentDate = new Date().toISOString().split('T')[0];
            this.baseButton.setAttribute('label', this.currentDate);
            if (this.labelText && label !== oldData.label) {
                this.labelText.setAttribute('value', label);
            }
            this.updateDateGrid();
            this.isOpen = false;
            this.gridContainer.setAttribute('visible', false);
        }
    },

    remove: function () {
        this.dateButtons.forEach(button => button.removeEventListener('click', this.selectDate));
    }
});